import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllKyc } from "../../redux/services/kycSlice";
import { convertUtcToIst } from "../../common/TimeUtils";
import moment from "moment-timezone";
import Pagination from "../../common/pagination";
import { onExportkycDetails } from "../../common/PdfFormat";

const KYC = () => {
  const dispatch = useDispatch();
const [page, setPage] = useState(0);
  const getKycData = useSelector((state) => state?.kyc?.kycData);
  const getAllKycApi = useCallback(async () => {
    try {
      await dispatch(getAllKyc({ page: page+ 1, limit: 1 }));
    } catch (error) {}
  }, [dispatch,page]);

  useEffect(() => {
    getAllKycApi();
  }, [getAllKycApi]);
  const exportToPDF = () => {
    const kycData = getKycData?.kyc_data || [];
    if (kycData?.length > 0) {
      onExportkycDetails(kycData);
    } else {
    }
  };
  return (
    <div className="bg-white shadow-lg h-full rounded-xl p-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          KYC Details
        </h2>

        <Pagination pageCount={getKycData?.state?.page_limit} onPageChange={(selectedItem) => setPage(selectedItem.selected)} />
       
        <button className="bg-[#124699] text-white h-fit px-4 py-2 rounded-lg font-semibold" onClick={exportToPDF}>Export PDF</button>
        </div>
        {getKycData?.kyc_data?.map((data, index) => {
          return (
            <div key={index}>
              <div className="bg-gray-100 p-4 rounded-lg mb-4">
                <h3 className="text-lg font-semibold text-gray-700">
                  User Information
                </h3>
                <hr className="my-2" />
                <div className="grid grid-cols-2 gap-4">
                  <p>
                    <span className="font-medium">Name:</span> 
                    {data.user.firstName} {data.user.lastName}
                  </p>
                  <p>
                    <span className="font-medium">Email:</span> 
                    {data.user.email}
                  </p>
                  <p>
                    <span className="font-medium">Phone:</span> 
                    {data.user.contact.countryCode} {data.user.contact.mobile}
                  </p>
                  <p>
                    <span className="font-medium">Date of Birth:</span> 
                    {moment(convertUtcToIst(data.user.dob)).format(
                      "DD-MM-YYYY"
                    )}
                  </p>
                  <p>
                    <span className="font-medium">City:</span> {data.user.city}
                  </p>
                  <p>
                    <span className="font-medium">Gender:</span> 
                    {data.user.gender}
                  </p>
                </div>
              </div>

              <div className="bg-gray-100 p-4 rounded-lg mb-4">
                <h3 className="text-lg font-semibold text-gray-700">
                  KYC Details
                </h3>
                <hr className="my-2" />
                <div className="grid grid-cols-2 gap-4">
                  <p>
                    <span className="font-medium">Proof Type:</span> 
                    {data.idProof}
                  </p>
                  <p>
                    <span className="font-medium">Proof Number:</span> 
                    {data.idNumber}
                  </p>
                  <p>
                    <span className="font-medium">KYC Status:</span>
                    <span
                      className={`ml-2 px-2 py-1 text-sm font-medium rounded-lg 
            ${data.status === "verified" ? "bg-green-100 text-green-700" : ""}
            ${data.status === "pending" ? "bg-yellow-100 text-yellow-700" : ""}
            ${data.status === "unverified" ? "bg-red-100 text-red-700" : ""}
          `}
                    >
                      {data.status.charAt(0).toUpperCase() +
                        data.status.slice(1)}
                    </span>
                  </p>
                </div>
              </div>

              {(data.frontSideImage || data.backSideImage) && (
                <div className="bg-gray-100 p-4 rounded-lg">
                  <h3 className="text-lg font-semibold text-gray-700">
                    Proof Images
                  </h3>
                  <hr className="my-2" />
                  <div className="grid grid-cols-2 gap-4">
                    {data.frontSideImage && (
                      <div>
                        <img
                          src={data.frontSideImage}
                          alt="Front Side"
                          className="w-full h-48 object-cover rounded-lg border"
                        />
                      </div>
                    )}
                    {data.backSideImage && (
                      <div>
                        <img
                          src={data.backSideImage}
                          alt="Back Side"
                          className="w-full h-48 object-cover rounded-lg border"
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KYC;
